import KeyboardBoxConnected from '@/launcher/components/connected/KeyboardBoxConnected.vue';
import StatusBoxConnected from '@/launcher/components/connected/StatusBoxConnected.vue';
import ControlsBoxLauncherConnected from '@/launcher/components/connected/ControlsBoxLauncherConnected.vue';
import ControlsBoxGameConnected from '@/launcher/components/connected/ControlsBoxGameConnected.vue';
import ReviewBoxConnected from '@/launcher/components/connected/ReviewBoxConnected.vue';
import SettingsBoxConnected from '@/launcher/components/connected/SettingsBoxConnected.vue';
import GamesBoxConnected from '@/launcher/components/connected/GamesBoxConnected';
import GamesDetailsBoxConnected from '@/launcher/components/connected/GamesDetailsBoxConnected';
import GamesSearchBoxConnected from '@/launcher/components/connected/GamesSearchBoxConnected';
import FilterBoxConnected from '@/launcher/components/connected/FilterBoxConnected.vue';
import LanguageSelectBoxConnected from '@/launcher/components/connected/LanguageSelectBoxConnected.vue';
import ThanksBoxConnected from '@/launcher/components/connected/ThanksBoxConnected.vue';
import PanelContainer from '@/launcher/components/shared/PanelContainer.vue';
import AdBoxConnected from '@/launcher/components/connected/AdBoxConnected';

export default {
  components: {
    KeyboardBoxConnected,
    StatusBoxConnected,
    ControlsBoxLauncherConnected,
    ControlsBoxGameConnected,
    ReviewBoxConnected,
    ThanksBoxConnected,
    LanguageSelectBoxConnected,
    SettingsBoxConnected,
    GamesDetailsBoxConnected,
    GamesBoxConnected,
    GamesSearchBoxConnected,
    FilterBoxConnected,
    PanelContainer,
    AdBoxConnected,
  },
};
